<template>
  <div class="common">
    <div class="commonTop flex flex-x flex-b">
      <div class="flex-x title flex-c">
        电商物流管理系统</div>
      <div class="flex flex-x commontopRight">
        <div class="flex flex-c" @click="quit" style="cursor: pointer;">
          <img src="../assets/onOff.png" width="30px" />
          安全退出
        </div>
      </div>
    </div>

    <div class="commonLeft">
      <el-menu background-color="#545c64" style="width: 100%;border-right: 0;" text-color="#fff"  :default-active="$route.path" active-text-color="#fff" :collapse="isCollapse" :router='true'  :unique-opened="true">
        <template v-for="router in routerList">
          <el-menu-item :index="router.path" :key="router.name" @click="routerTo(router.path)" v-if="!router.sub">
            <i :class="router.icon" v-if="router.icon"></i>
            <span slot="title">{{router.name}}</span>
          </el-menu-item>
          <el-submenu :index="router.path" :key="router.name" v-if="router.sub">
            <template slot="title">
              <i :class="router.icon" v-if="router.icon"></i>
              <span>{{router.name}}</span>
            </template>
            <template v-for="item in router.sub">
              <el-menu-item :index="item.path" :key="item.name" v-if="!item.sub">
                <i :class="item.icon" v-if="item.icon"></i>
                {{item.name}}
              </el-menu-item>
              <el-submenu :index="item.path" :key="item.name" v-if="item.sub">
                <template slot="title">
                  <i :class="item.icon" v-if="item.icon"></i>
                  <span>{{item.name}}</span>
                </template>
                <el-menu-item v-for="zitem in item.sub" :index="zitem.path" :key="zitem.name">
                  <i :class="zitem.icon" v-if="zitem.icon"></i>
                  {{zitem.name}}
                </el-menu-item>
              </el-submenu>
            </template>
          </el-submenu>
        </template>
      </el-menu>
    </div>
    <div class="commonRight">
      <router-view :isCollapse="isCollapse" />
      <!-- <div class="commonRightBox">
        
      </div> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    data: function () {
      return {
        isCollapse: false,
        defaultActive: this.$route.path,
        routerList: [{
          name: '寄件人管理',
          path: '/mail',
          icon: 'el-icon-suitcase-1'
        }, {
          name: '收件人管理',
          path: '/receipt',
          icon: 'el-icon-receiving'
        },  {
            name: '销售管理',
            path: '/personnel',
            icon: 'el-icon-user-solid',

        }, {
          name: '订单管理',
          path: '/orderRecord',
          icon: 'el-icon-truck'
        }, {
            name: '设置管理',
            path: '/payMethod',
            icon: 'el-icon-s-cooperation',
            sub: [{
              name: '运费方式',
              path: '/payMethod',
            }, {
              name: '送货方式',
              path: '/deliveryMethod',
            }, {
              name: '打印机',
              path: '/print',
            },{
              name:'客服配置',
              path: '/service',
            }]
        }, {
            name: '图片管理',
            path: '/bannerImage',
            icon: 'el-icon-picture'
          }, {
          name: '账号管理',
          path: '/admin',
          icon: 'el-icon-s-tools',
        }]
      }
    },
    
    methods: {
      routerTo: function (path) {
        this.$router.push(path);
      },
      quit: function () {
        this.http.post('/login/logout').then(() => {
          this.$router.replace("/");
        });
      }
    }
  }
</script>